<div class="h-[calc(100vh-48px)] overflow-y-auto hide-scrollbar p-4">
  <div class="mb-4 flex justify-end items-center">
    <button
      (click)="openDialog$.next(undefined)"
      icon="tuiIconPlus"
      size="s"
      tuiButton
    >
      Создать
    </button>
  </div>

  <tui-loader [overlay]="true" [showLoader]="!!(loading$ | async)">
    <table
      *tuiLet="(items$ | async) ?? [] as items"
      tuiTable
      class="journal-table w-full cursor-pointer"
      [columns]="columns"
    >
      <thead>
        <tr tuiThGroup>
          @for (header of tableHeaders; track header.value) {
            <th tuiTh>{{ header.name }}</th>
          }
          <th tuiTh></th>
        </tr>
      </thead>
      <tbody tuiTbody>
        @for (item of items; track item.id) {
          <tr tuiTr (dblclick)="openDialog$.next(item)">
            @for (header of tableHeaders; track header.value) {
              <td *tuiCell="header.value" tuiTd>
                @switch (header.value) {
                  @case ('date') {
                    {{ item.date | date: 'dd.MM.yyyy' }}
                  }
                  @case ('cost') {
                    {{ item.cost | number: '1.2-2' | spaceNumber }}
                  }
                  @default {
                    {{ item[header.value] }}
                  }
                }
              </td>
            }
            <td tuiTd *tuiCell="'actions'">
              <div class="flex gap-x-2 justify-end">
                <button
                  (click)="getSourceFile$.next(item.id!)"
                  appearance="icon"
                  tuiIconButton
                  size="s"
                  icon="tuiIconDownload"
                ></button>
                <button
                  (click)="openDialog$.next(item)"
                  appearance="icon"
                  tuiIconButton
                  size="s"
                  icon="tuiIconEdit"
                ></button>
              </div>
            </td>
          </tr>
        } @empty {
          <tr>
            <td
              [attr.colspan]="columns.length"
              class="text-center py-10 text-gray-500"
            >
              Нет инвойсов
            </td>
          </tr>
        }
      </tbody>
    </table>
  </tui-loader>
</div>
